import React from "react";
var __jsx = React.createElement;
import stl from "./StepsContainer.module.css";
var SingleStep = function SingleStep(_ref) {
  var title = _ref.title,
    pointNumber = _ref.pointNumber,
    active = _ref.active,
    done = _ref.done;
  return /*#__PURE__*/React.createElement("div", {
    className: [stl.singleStepContainer, active ? stl.active : undefined, done ? stl.done : undefined].join(" ")
  }, /*#__PURE__*/React.createElement("span", null, pointNumber), " ", /*#__PURE__*/React.createElement("strong", null, title));
};
export default SingleStep;